import React from 'react';
import '../../design/footer.css';

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-links">
          <a href="mailto:support@deliquentauction.com">
            Contact Us
          </a>
          <a href="/terms">Terms</a>
          <a href="/privacy">Privacy</a>
        </div>
        <div className="footer-logos">
            <span className="created-by">Created by</span>
            <a href="mailto:codeifyllc@gmail.com">
                <img
                    src="/codeifyllc_logo.png"
                    alt="Codeify LLC Logo"
                    className="footer-logo"
                />
            </a>

            <span className="created-by"> In Partnership With </span>
            <a
                href="https://itrust.company"
                target="_blank"
                rel="noopener noreferrer"
            >
                <img
                src="/intergrated_trust_logo.png"
                alt="InteRgrated Trust Logo"
                className="footer-logo"
                />
            </a>
        </div>

        <div className="footer-copy">
          <span>© 2025 Deliquent Auction</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
